import { ApiCallState } from "../Utils";
import { IndirectCost } from "../IndirectCost/IndirectCost.type";
import { PettyCashRequisition } from "../PettyCashRequisition/PettyCashRequisition.type";
import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";

export type PettyCashReplenishment = {
  id: number;
  no?: number;
  date: string;
  description: string;
  indirect_cost_id: number;
  indirect_cost?: IndirectCost;
  petty_cash_requisition_id?: number;
  petty_cash_requisition?: PettyCashRequisition;
  project_id: number;
  project?: Project;
  name_user_id: number;
  name_user?: User;
  amount_before_vat: number;
  current_balance?: number;
  replenishment_amount: number;
  user_id: number;
  petty_cash_replenishment_views?: any[];
  petty_cash_replenishment_checkeds?: any[];
  petty_cash_replenishment_approveds?: any[];
  petty_cash_replenishment_authorizeds?: any[];
  createdAt?: any;
  updatedAt?: any;
};

export type PettyCashReplenishmentStateTypes = {
  fetchAll: ApiCallState<PettyCashReplenishment[]>;
  fetchOne: ApiCallState<PettyCashReplenishment | {}>;
};

export const PettyCashReplenishmentActionTypes = {
  FETCH_ALL_PETTY_CASH_REPLENISHMENT: "FETCH_ALL_PETTY_CASH_REPLENISHMENT",
  FETCH_ALL_PETTY_CASH_REPLENISHMENT_RESET: "FETCH_ALL_PETTY_CASH_REPLENISHMENT_RESET",
  FETCH_ALL_PETTY_CASH_REPLENISHMENT_FAILURE: "FETCH_ALL_PETTY_CASH_REPLENISHMENT_FAILURE",
  FETCH_ALL_PETTY_CASH_REPLENISHMENT_SUCCESS: "FETCH_ALL_PETTY_CASH_REPLENISHMENT_SUCCESS",

  FETCH_ONE_PETTY_CASH_REPLENISHMENT: "FETCH_ONE_PETTY_CASH_REPLENISHMENT",
  FETCH_ONE_PETTY_CASH_REPLENISHMENT_RESET: "FETCH_ONE_PETTY_CASH_REPLENISHMENT_RESET",
  FETCH_ONE_PETTY_CASH_REPLENISHMENT_FAILURE: "FETCH_ONE_PETTY_CASH_REPLENISHMENT_FAILURE",
  FETCH_ONE_PETTY_CASH_REPLENISHMENT_SUCCESS: "FETCH_ONE_PETTY_CASH_REPLENISHMENT_SUCCESS",
};
